import { ethers } from "ethers";

export default function formatUnits(...args) {
  return parseFloat(ethers.utils.formatUnits(...args));
}
